import { render, staticRenderFns } from "./CampaignItem.vue?vue&type=template&id=48aedfd2&scoped=true"
import script from "./CampaignItem.vue?vue&type=script&lang=js"
export * from "./CampaignItem.vue?vue&type=script&lang=js"
import style0 from "./CampaignItem.vue?vue&type=style&index=0&id=48aedfd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aedfd2",
  null
  
)

export default component.exports